export default "__VITE_ASSET__QpSHCVdm6C55TUBZK905xw__"